import { logger } from '@/services/logger/logger.client'
import { isBrowser } from '@/utils/env'
import { type ApolloLink } from '@apollo/client'
import { setContext } from '@apollo/client/link/context'
import { refreshAccessToken } from '../authApi/oauth'
import {
  getAccessTokenClientSide,
  getRefreshTokenClientSide,
  resetAuthTokensClientSide,
  saveAuthTokensClientSide,
} from '../authApi/persist'
import { isAccessTokenExpired } from '../authApi/utils'
import { getShopSessionIdClient } from '../shopSession/ShopSession.helpers'

export const createHeadersLink = (defaultHeaders?: Record<string, string>): ApolloLink => {
  return setContext(async (_, prevContext) => {
    const headers = { ...defaultHeaders }
    if (isBrowser()) {
      Object.assign(headers, {
        ...(await performTokenRefreshIfNeeded()),
        ...getShopSessionHeader(),
      })
    }
    return { headers, ...prevContext }
  })
}

export const performTokenRefreshIfNeeded = async () => {
  const currentAccessToken = getAccessTokenClientSide()
  if (!currentAccessToken) return

  const hasExpired = isAccessTokenExpired(currentAccessToken)

  if (!hasExpired) return { authorization: `Bearer ${currentAccessToken}` }

  const currentRefreshToken = getRefreshTokenClientSide()
  if (!currentRefreshToken) {
    logger.error('Token refresh: no refresh token found')
    resetAuthTokensClientSide()
    return
  }

  const { accessToken, refreshToken } = await refreshAccessToken(currentRefreshToken)

  saveAuthTokensClientSide({ accessToken, refreshToken })

  return { authorization: `Bearer ${accessToken}` }
}

export const getShopSessionHeader = () => {
  const shopSessionId = getShopSessionIdClient()
  if (shopSessionId) return { 'Hedvig-ShopSessionId': shopSessionId }
  return undefined
}
